export { type Navigation, NavigationProvider, type NavigationTarget, useNavigation } from "./NavigationContext";
